/**
 * @package DMV Online Services
 * @version 1.2.0
 */
/* global ga */

import { ct_links } from '../../helpers';
import { vr_links } from '../../helpers';
import { cdl_links } from '../../helpers';
import { mc_links } from '../../helpers';

$(document).ready(function() {

  const channels = [
    {
      selector: 'a.ols',
      campaign: '123 Links',
      category: 'OLS Guides Tracking',
    },
    {
      selector: '#page-content .dmv-guides a',
      campaign: 'Guides Ads (Content Top)',
      category: 'OLS Guides Tracking',
    },
    {
      selector: '#sidebar .dmv-guides a',
      campaign: 'Guides Ads (Sidebar)',
      category: 'OLS Guides Tracking',
    },
    {
      selector: '.ols-item-links a',
      campaign: 'Homepage OLS',
      category: 'OLS Guides Tracking',
    },
    {
      selector: 'body.home .dmv-advisors-widget input[type="submit"]',
      campaign: 'Homepage widget',
      category: 'DMV Advisors',
      label: 'Advisors',
    },
    {
      selector: 'body.template-state-homepage .dmv-advisors-widget input[type="submit"]',
      campaign: 'State page widget',
      category: 'DMV Advisors',
      label: 'Advisors',
    },
    {
      selector: 'body.page-template-default .dmv-advisors-widget input[type="submit"]',
      campaign: 'Content bottom widget',
      category: 'DMV Advisors',
      label: 'Advisors',
    },
  ];

  const gtm_target = 'gtm1';
  const slug = window.location.pathname.split('/').slice(-1).pop();
  const getEventLabelforOLS = function(path) {
    if (ct_links.includes(path)) {
      return 'CT';
    } else if (vr_links.includes(path)) {
      return 'VR';
    } else if (cdl_links.includes(path)) {
      return 'CDL';
    } else if (mc_links.includes(path)) {
      return 'MOTO';
    } else {
      return 'DL';
    }
  }

  let eventLabel = '';

  channels.forEach(channel => {
    eventLabel = channel.label ? channel.label : getEventLabelforOLS(slug);

    if ($(channel.selector).length && typeof ga === 'function') {
      ga(`${gtm_target}.send`, 'event', 'pageview', {
        'eventCategory': channel.category,
        'eventAction': 'Page View',
        'eventLabel': eventLabel,
        'campaignName': channel.campaign,
      });
    }

    $(channel.selector).on('click', function() {
      if (typeof ga === 'function') {
        ga(`${gtm_target}.send`, 'event', 'link', 'click',
          $(this).attr('href'), {
          'eventCategory': channel.category,
          'eventAction': 'Ad Click',
          'eventLabel': eventLabel,
          'campaignName': channel.campaign,
          'campaignKeyword': $.trim($(this).text()),
        });
      }
    });
  });
});



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-ols/index.js